import React, {useState} from "react";
import {BsFillExclamationTriangleFill} from "react-icons/bs";
import Modal from "react-modal";

import Styles from "./ModalEncerrarLoja.module.css";

import {PasswordsType} from "../EntrepreneurAccountData";
import {useTranslation} from "react-i18next";

Modal.setAppElement("#root");

type ModalEncerrarLojaProps = {
  isOpen: boolean;
  handleExcluir: (senha: string) => Promise<boolean>; // Atualizado para refletir o retorno booleano
  handleCancelar: () => void;
  passwords: PasswordsType;
  setPasswords: React.Dispatch<React.SetStateAction<PasswordsType>>;
};

export default function ModalEncerrarLoja({
  isOpen,
  handleExcluir,
  handleCancelar,
  passwords,
  setPasswords,
}: ModalEncerrarLojaProps): JSX.Element {

    const { t } = useTranslation();

  const [errorMessage, setErrorMessage] = useState("");

  const handleExcluirDefault = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault(); 
    setErrorMessage("");

    if (passwords.password !== passwords.repeatedPassword) {
      setErrorMessage(`${t(`accountMenu.passwordsDontMatch`)}. ${t(`accountMenu.tryAgain`)}`);
    } else {
      const senhaCorreta = await handleExcluir(passwords.password);
      if (senhaCorreta) {
        handleCancelarDefault();
      } else {
        setErrorMessage(`${t(`accountMenu.incorrectPassword`)}. ${t(`accountMenu.tryAgain`)}`);
      }
    }
  };

  const handleCancelarDefault = () => {
    setErrorMessage("");
    handleCancelar();
  }

  return (
    <Modal isOpen={isOpen} className={Styles.ModalEncerraLoja}>
      <form className={Styles.modalContainer} onSubmit={event => handleExcluirDefault(event)}>
        <div className={Styles.iconeContainer}>
          <BsFillExclamationTriangleFill className={Styles.iconeAtencao} />
        </div>
        <div className={Styles.modalCabecalho}>
          <h1 className={Styles.cabecalhoText}>
            {t(`accountMenu.confirmFinishStore`)}
          </h1>
        </div>
        <div className={Styles.inputContainer}>
          <div>
            <h3> {t(`accountMenu.insertPassword`)}:</h3>
            <input
            required
              type="password"
              value={passwords.password}
              onChange={(event) =>
                setPasswords((prev) => {
                  return { ...prev, password: event.target.value };
                })
              }
            />
          </div>
          <div>
            <h3> {t(`accountMenu.insertPasswordAgain`)}:</h3>
            <input
            required
              type="password"
              value={passwords.repeatedPassword}
              onChange={(event) =>
                setPasswords((prev) => {
                  return { ...prev, repeatedPassword: event.target.value };
                })
              }
            />
          </div>
        </div>
        {errorMessage && (
          <span className={Styles.errorMessage}>{errorMessage}</span>
        )}
        <div className={Styles.buttons}>
          <button type="button" onClick={handleCancelarDefault}>
            {t(`accountMenu.cancel`)}
          </button>
          <button type="submit">{t(`accountMenu.finish`)}</button>
        </div>
      </form>
    </Modal>
  );
}
